import { FcGoogle } from "react-icons/fc"
import { FaGithub } from "react-icons/fa"
import { Button } from "../../../ui/shadcn/button"

export function GoogleButton({ ...props }: React.ComponentProps<"button">) {
    return (
        <Button
            {...props}
            variant="outline"
            className="bg-transparent text-inherit hover:bg-transparent hover:border-primary"
        >
            <FcGoogle className="h-5 w-5" />
            Google
        </Button>
    )
}

export function GithubButton({ onClick }: { onClick: () => void }) {
    return (
        <Button
            variant="outline"
            onClick={onClick}
            className="bg-transparent text-inherit hover:bg-transparent hover:border-primary"
        >
            <FaGithub className="h-5 w-5" />
            GitHub
        </Button>
    )
}
